var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 61,
    viewBox: "0 0 132 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M119.004 59.354H14.2975C7.87552 54.8868 -3.1256 42.9366 4.24571 30.874C11.617 18.8114 34.6803 18.5884 45.2905 19.9847C52.8293 12.7251 62.5461 -0.450839 81.3094 1.55952C100.073 3.56988 109.789 21.6599 107.277 30.874C111.186 29.4779 120.846 29.0312 128.218 38.4128C135.589 47.7945 125.146 56.2827 119.004 59.354Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCloud);
export default __webpack_public_path__ + "static/media/small-cloud.9d5e3c97255cb14468cc27b76142f092.svg";
export { ForwardRef as ReactComponent };